/**
 * @author limy
 */
import api from '@/services/api'
import {METHOD, request} from '@/utils/request'

export const dataApi = {
	async getFormDetail(keyId) {
		return request(api.operate.SEND_WELCOME_MSG +'/'+ keyId, METHOD.GET);
	},
	async saveFormDetail(result) {
		return request(api.operate.SEND_WELCOME_MSG, METHOD.POST, result);
	},
	/**
	 * 启用
	 */
	async updateIsUse(keyId) {
		return request(api.operate.SEND_WELCOME_MSG + '/updateIsUse?messageId=' + keyId, METHOD.GET);
	},
}

export default {dataApi}